export const KIND_LABELS = {
  verification: "Confirm email",
  verification_reminder: "Confirm reminder (24h)",
  receipt: "Buyer receipt",
  purchase_alert: "Purchase alert (you)",
  launch: "Launch announcement",
  launch_test: "Launch (test copy)",
  rich_welcome: "Rich's welcome letter",
  rich_welcome_test: "Rich's welcome (test copy)",
  healer_gratitude: "Healer's Gratitude (buyer welcome)",
  lead_reply: "B2B lead reply",
  welcome_1: "Welcome · Day 1",
  welcome_2: "Welcome · Day 3",
  welcome_3: "Welcome · Day 6",
  streak_reminder: "Daily ground reminder",
  grace_nudge: "Grace-day nudge",
  grace_nudge_test: "Grace-day (test copy)",
  inactive_nudge: "Door's still open (14 days quiet)",
  checkout_nudge: "Checkout follow-up",
  checkout_nudge_test: "Checkout follow-up (test copy)",
  weekly_review: "Sunday review",
  password_reset: "Password reset",
  digest: "Weekly digest (you)",
  first_sale: "First sale (you)",
  sale_milestone: "Sale milestone (you)",
  other: "Other",
};
